<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      modal-alignment="center"
      modal-size="large"
      @close-modal="closeModal"
    >
      <template slot="header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span>
            <app-icon :name="'x'"></app-icon>
          </span>
        </button>
      </template>
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
        >
          <div class="form-group row align-items-center">
            <label for="package" class="col-sm-3 mb-0">
              {{ $t("package") }}
            </label>
            <app-input
              id="package"
              class="col-sm-9"
              type="text"
              v-model="package"
              :read-only="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="inputs_name" class="col-sm-3 mb-0">
              {{ $t("business_category") }}
            </label>
            <app-input
              id="title"
              class="col-sm-9"
              type="text"
              v-model="data.category_name.value"
              :read-only="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="payment_type" class="col-sm-3 mb-0">
              {{ $t("payment_methods") }}
            </label>
            <app-input
              id="payment_type"
              class="mt-2 pt-1 col-sm-9"
              type="radio"
              :list="paymenttype"
              v-model="payment_type.value"
              :required="true"
            />
          </div>
        </form>
      </template>
      <template slot="footer">
        <!-- <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
        >
          {{ $t("close") }}
        </button> -->
        <!-- <button type="button" class="btn btn-primary" @click="submit">
          {{ $t("checkout") }}
        </button> -->
        <app-load-more
                      :preloader="preloader"
                      :label="$t('checkout')"
                      type="submit"
                      class-name="btn btn-primary"
                      @submit="submit"
                    />
      </template>
    </app-modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import {
  PACKAGE_SHOW,
  PAYMENT_METHODS_list,
  BUSINESS_CATEGORY,
  CASH_PAYMENT_INVOICE,
} from "../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    data: Object,
  },
  data() {
    return {
      inputs: {},
      paymenttype: [],
      payment_type: {
        value: "Cash",
      },
      package: "",
      // payment_type: "",
      preloader: false,
      modalId: "payment-Modal",
      modalTitle: this.$t("payment_method"),
    };
  },
  methods: {
    submit() {
      this.preloader = true;
      this.inputs.company_id = this.data.company_id;
      this.inputs.category_id = this.data.category_id;
      this.inputs.package_id = this.data.package_id;
      axiosPost(BUSINESS_CATEGORY, this.inputs)
        .then((res) => {
          if (this.payment_type.value == "Cash") {
            // location.replace("/kanban-view");
            this.cashPaymentInvoice(this.inputs);
          } else {
            let id = this.data.package_id;
            location.replace("/admin/stripePay/" + id);
          }
          // location.replace("/admin/stripePay/" + id);
        })
        .catch((error) => {
          
        });

      // this.save(this.inputs);
    },

    cashPaymentInvoice(data) {
      // this.inputs.package_id = this.data.package_id;
      axiosPost(CASH_PAYMENT_INVOICE, data)
        .then((res) => {
          location.replace("/kanban-view");
        })
        .catch((error) => {
          
        });
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getPackage() {
      axiosGet(PACKAGE_SHOW + "/" + this.data.package_id)
        .then((res) => {
          
          this.package = res.data.title;
        })
        .catch((error) => {
          
        });
    },
    getPaymentMethos() {
      axiosGet(PAYMENT_METHODS_list)
        .then((res) => {
          this.paymenttype = res.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    console.info(this.data)
    this.getPackage();
    this.getPaymentMethos();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
